import { render, staticRenderFns } from "./FrameStories.vue?vue&type=template&id=76cd398f&scoped=true&"
import script from "./FrameStories.vue?vue&type=script&lang=js&"
export * from "./FrameStories.vue?vue&type=script&lang=js&"
import style0 from "./FrameStories.vue?vue&type=style&index=0&id=76cd398f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd398f",
  null
  
)

export default component.exports